// DB module format
export interface BaseScheduler {
  recurrenceType: RecurrenceType;

  recurrentDaySun: number;
  recurrentDayMon: number;
  recurrentDayTue: number;
  recurrentDayWed: number;
  recurrentDayThu: number;
  recurrentDayFri: number;
  recurrentDaySat: number;

  runEvery: number;
  runPer: RepeatInterval;

  startDate: {
    date: string;
    hours: number;
    minutes: number;
  };
}

// enums for ui settings
export enum RecurrenceType {
  SCHEDULE = 1,
  WEEKDAYS = 2,
}

export enum RepeatInterval {
  HOURS = 1,
  DAYS = 2,
  WEEKDAYS = 3,
}
